(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal && typeof this.searchModal.close === 'function') {
        this.searchModal.close(false);
      }
    }
  }

  customElements.define('sticky-header', StickyHeader);

  /* ----- Predictive search: move focus into results + roving tabindex ----- */
  (function () {
    const INPUT_SELECTOR = '.search-modal__form .field__input[type="search"]';
    const PANEL_SELECTOR = '[data-predictive-search]';
    const OPTION_SELECTOR = '.predictive-search__results-list [role="option"]';
    const FOCUSABLE_SELECTOR = `${OPTION_SELECTOR} a, ${OPTION_SELECTOR} button`;

    function getPanelFromInput(input) {
      const form = input.closest('.search-modal__form');
      return form ? form.querySelector(PANEL_SELECTOR) : null;
    }

    function getFocusableOptions(panel) {
      return panel ? Array.from(panel.querySelectorAll(FOCUSABLE_SELECTOR)) : [];
    }

    function setActiveByIndex(panel, idx, links) {
      if (!panel || !links || !links.length) return;

      // reset
      panel.querySelectorAll(OPTION_SELECTOR).forEach(li => li.setAttribute('aria-selected', 'false'));
      links.forEach(a => a.setAttribute('tabindex', '-1'));

      // set active
      const active = links[idx];
      if (!active) return;

      const li = active.closest('[role="option"]');
      if (li) li.setAttribute('aria-selected', 'true');

      active.setAttribute('tabindex', '0');
      active.focus({ preventScroll: false });
    }

    function focusFirstResult(panel) {
      const links = getFocusableOptions(panel);
      if (!links.length) return false;

      const isHidden = panel.hasAttribute('hidden') || panel.getAttribute('aria-hidden') === 'true';
      if (isHidden) return false;

      setActiveByIndex(panel, 0, links);
      return true;
    }

    function closePredictivePanel(panel, inputEl) {
      if (panel) {
        panel.setAttribute('hidden', '');
        panel.setAttribute('aria-hidden', 'true');

        panel
          .querySelectorAll(`${OPTION_SELECTOR} [tabindex="0"]`)
          .forEach(el => el.setAttribute('tabindex', '-1'));
        panel
          .querySelectorAll(OPTION_SELECTOR)
          .forEach(li => li.setAttribute('aria-selected', 'false'));
      }
      if (inputEl) {
        inputEl.setAttribute('aria-expanded', 'false');
      }
    }

    function handleResultsKeydown(e) {
      const panel = e.currentTarget;
      const links = getFocusableOptions(panel);
      if (!links.length) return;

      const currentIndex = links.findIndex(el => el === document.activeElement);
      if (currentIndex < 0) return;

      switch (e.key) {
        case 'ArrowDown':
          e.preventDefault();
          setActiveByIndex(panel, Math.min(currentIndex + 1, links.length - 1), links);
          break;
        case 'ArrowUp':
          e.preventDefault();
          setActiveByIndex(panel, Math.max(currentIndex - 1, 0), links);
          break;
        case 'Home':
          e.preventDefault();
          setActiveByIndex(panel, 0, links);
          break;
        case 'End':
          e.preventDefault();
          setActiveByIndex(panel, links.length - 1, links);
          break;
        case 'Escape': {
          e.preventDefault();
          const form = document.activeElement?.closest('.search-modal__form');
          if (!form) break;

          const resultsPanel = form.querySelector(PANEL_SELECTOR);
          const inputEl = form.querySelector(INPUT_SELECTOR);

          closePredictivePanel(resultsPanel, inputEl);
          if (inputEl) inputEl.focus();
          break;
        }
      }
    }


  })();

  /* Float labels on autofill/initial value */
  document.querySelectorAll('.field.floating .field__input').forEach(function (el) {
    var set = function () {
      if (el.value && el.value.trim() !== '') {
        el.classList.add('has-value');
      } else {
        el.classList.remove('has-value');
      }
    };
    set();
    el.addEventListener('input', set);
    el.addEventListener('change', set);
  });

  } catch(e) { console.error(e); }
})();
})();
